module.exports = __webpack_public_path__ + "img/Philippines.6f7904bb.png";